function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

// 恢复原始的复制功能绑定，确保简单产品页面能复制
document.addEventListener('DOMContentLoaded', function () {
var copyMeElement = document.querySelector('.copyme');

if (copyMeElement) {
  copyMeElement.addEventListener('click', function () {
    var dataToCopy = copyMeElement.getAttribute('data-copy');
    var tempInput = document.createElement('input');
    tempInput.value = dataToCopy;
    document.body.appendChild(tempInput);
    copyMeElement.classList.add('highlighted');
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    setTimeout(function () {
      copyMeElement.classList.remove('highlighted');
    }, 2000);
  });
} else {
  console.warn('No .copyme element found on page load');
}
});

class VariantSelects extends HTMLElement {
constructor() {
  super();
  // 变体切换逻辑仍需
  this.addEventListener('change', this.onVariantChange);

  // 如果页面上有 SKU 复制功能需要，保留；不需要可删除
  this.reinitializeCopyEvent?.();
}

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    //console.log(this.currentVariant );
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
      // 添加调试
  console.log('🎯 renderProductInfo called');
  console.log('Current variant ID:', this.currentVariant?.id);
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
  
    // 获取元素并预先检查
    const qtyCount = document.querySelector('.qty_count');
    const nostock = document.querySelector('.nostock');
    const nostock3 = document.querySelector('.nostock3');
    const mto = document.querySelector('.mto');
    const inventoryWrapper = document.querySelector('.inventoryWrapper');
    const placeholder = document.querySelector('.placeholder[data-si-trigger="true"]');
    
    // 预先隐藏元素
    //if (qtyCount) qtyCount.style.display = 'none';
    //if (nostock) nostock.style.display = 'none';
    //if (mto) mto.style.display = 'none';
    
    // 检查是否是Dropship产品
    let isDropship = false;
    if (inventoryWrapper && inventoryWrapper.dataset.isDropship === 'true') {
      isDropship = true;
      // 添加isdropship类
      if (qtyCount) {
        qtyCount.classList.add('isdropship');
      }
    } else if (qtyCount) {
      // 确保非Dropship产品移除该类
      qtyCount.classList.remove('isdropship');
    }
  
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // 防止因用户快速切换变体导致不必要的UI更新
        if (this.currentVariant.id !== requestedVariantId) return;
  
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const preOrderDiv = document.querySelector('.nostock2');
  
        // 获取库存信息
const variantInventoryElement = html.getElementById(`variantInventory`);
const variantInventory = variantInventoryElement
  ? parseInt(variantInventoryElement.innerHTML.replace(/[^0-9\-]/g, ''))
  : this.currentVariant.inventory_quantity || 0;
        
        // 获取DOM元素
        const variantInventoryDom = document.getElementById(`variantInventory`);
        const hasInventoryElement = document.getElementById(`hasInventory`);
        const formButton = document.getElementById(`formButton`); // nostock 块的 formButton
        const formButtonMto = document.getElementById(`formButtonMto`); // mto 块的 formButton
        let currentPlaceholder = document.querySelector('.placeholder[data-si-trigger="true"]');
        let siTrigger = document.querySelector('.SI_trigger');
  
        // 修改库存文本 - 添加"In Stock!"
        if (variantInventoryDom) {
          variantInventoryDom.textContent = `${variantInventory} In Stock!`;
        }
        
        // 修改发货文本 - 根据是否Dropship产品
if (hasInventoryElement) {
  if (isDropship) {
    hasInventoryElement.textContent = "Ships from Vendor Directly-Delivery Time Varies.";
    hasInventoryElement.style.display = 'inline-block';
  } else {
    hasInventoryElement.textContent = "";
    hasInventoryElement.style.display = 'none';
  }
}
  
        // 获取产品标签
        let tags = [];
        if (currentPlaceholder || siTrigger) {
          const productData = currentPlaceholder?.dataset.productData || siTrigger?.getAttribute('data-product-data');
          try {
            const product = JSON.parse(productData);
            tags = product.tags || [];
            // 也通过标签检测是否是Dropship
            isDropship = isDropship || tags.some(tag => tag.toLowerCase() === 'dropship');
            
            // 如果是Dropship产品，确保添加isdropship类
            if (isDropship && qtyCount) {
              qtyCount.classList.add('isdropship');
            }
          } catch (e) {
            console.error('Error parsing product data:', e);
          }
        }
        
        const hasSpOrMtoTag = tags.some(tag =>
          tag.toLowerCase().includes('sp_') || tag.toLowerCase().includes('mto_')
        );
        const hasMtoTag = tags.some(tag => tag.toLowerCase().includes('mto_'));
  
        // 更新 inventoryWrapper 的类名
        if (inventoryWrapper) {
          inventoryWrapper.classList.remove('inventoryWrapper--qty-mto', 'inventoryWrapper--nostock');
          if (variantInventory > 0 || hasMtoTag) {
            inventoryWrapper.classList.add('inventoryWrapper--qty-mto');
          } else {
            inventoryWrapper.classList.add('inventoryWrapper--nostock');
          }
        }
  
        // 更新 inventoryDestination 的内容
        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        }
        // === 新增：替换后重新获取 hasInventory 并控制显示 ===
const hasInventoryElementNew = inventoryDestination ? inventoryDestination.querySelector('#hasInventory') : null;
if (qtyCount) qtyCount.style.display = 'flex'; // 保证父级可见
if (hasInventoryElementNew) {
  if (isDropship) {
    hasInventoryElementNew.textContent = "Ships from Vendor Directly-Delivery Time Varies.";
    hasInventoryElementNew.style.display = 'inline-block';
  } else {
    hasInventoryElementNew.textContent = "";
    hasInventoryElementNew.style.display = 'none';
  }
}
  // 在更新所有元素后，添加 .nostock3 的更新：
const nostock3Source = html.querySelector('.nostock3');
const nostock3Destination = document.querySelector('.nostock3');
if (nostock3Source && nostock3Destination) {
  // 完全替换
  nostock3Destination.innerHTML = nostock3Source.innerHTML;
  nostock3Destination.style.cssText = nostock3Source.style.cssText;
  
  // 复制所有属性
  Array.from(nostock3Source.attributes).forEach(attr => {
    nostock3Destination.setAttribute(attr.name, attr.value);
  });
  console.log('Updated nostock3 from AJAX response');
}
        // 更新库存显示逻辑
        if (variantInventory > 0) {
          if (variantInventoryDom) {
            variantInventoryDom.style.display = 'inline-block';
            // 确保库存文本显示正确
            variantInventoryDom.textContent = `${variantInventory} In Stock!`;
          }
          //if (hasInventoryElement) {
            //hasInventoryElement.style.display = 'inline-block';
          //}
          if (qtyCount) qtyCount.style.display = 'flex'; // 显示 qty_count
          if (formButton) formButton.style.display = 'none';
          if (formButtonMto) formButtonMto.style.display = 'none';
          if (nostock) nostock.style.display = 'none';
          if (nostock3) nostock3.style.display = 'none';
          if (mto) mto.style.display = 'none';
          if (siTrigger) siTrigger.style.display = 'none';
          if (currentPlaceholder) currentPlaceholder.style.display = 'none';
          const shippingDateElement = document.querySelector(`[data-shipping-date]`);
          if (shippingDateElement) shippingDateElement.style.display = 'block';
          if (preOrderDiv) preOrderDiv.style.display = 'none';
        } else {
          const shippingDateElement = document.querySelector(`[data-shipping-date]`);
          if (shippingDateElement) shippingDateElement.style.display = 'none';
          
          if (variantInventoryDom) {
            variantInventoryDom.style.display = 'none';
          }
// 现在使用更新后的元素进行检查
  const updatedNostock3 = document.querySelector('.nostock3');
  console.log('Checking updated nostock3:', updatedNostock3?.outerHTML);
  console.log('Has ETA text:', updatedNostock3?.textContent.includes('ETA:'));
  
  const hasEtaInText = updatedNostock3 && updatedNostock3.textContent.includes('ETA:');
  
  if (hasEtaInText) {
    // 有 ETA，确保 .nostock3 显示
    if (updatedNostock3) updatedNostock3.style.display = 'flex';
    // 隐藏 preOrderDiv
    if (preOrderDiv) preOrderDiv.style.display = 'none';
    console.log('ETA found in text, showing nostock3');
  } else {
    // 没有 ETA，显示 pre-order
    if (preOrderDiv) preOrderDiv.style.display = 'block';
    console.log('No ETA, showing pre-order');
  }
          if (preOrderDiv) preOrderDiv.style.display = 'block';
          //if (hasInventoryElement) {
            //hasInventoryElement.style.display = 'none';
          //}
          if (qtyCount) qtyCount.style.display = 'none'; // 隐藏 qty_count
  
          // 根据 hasMtoTag 决定显示 mto 还是 nostock
          if (hasMtoTag) {
            if (mto) mto.style.display = 'flex';
            if (formButtonMto) formButtonMto.style.display = 'inline-block';
            if (nostock) nostock.style.display = 'none';
            if (nostock3) nostock3.style.display = 'none';
            if (formButton) formButton.style.display = 'none';
            if (siTrigger) siTrigger.style.display = 'none';
            if (currentPlaceholder) currentPlaceholder.style.display = 'none';
          } else {
            if (nostock) {
              nostock.style.display = 'flex'; // 确保 nostock 块显示
              nostock3.style.display = 'flex'; // 确保 nostock 块显示
              // 确保子元素也可见
              if (formButton) formButton.style.display = 'inline-block';
              const orElement = nostock.querySelector('span');
              if (orElement && orElement.textContent === 'or') {
                orElement.style.display = 'inline-block';
              }
            }
            if (mto) mto.style.display = 'none';
            if (formButtonMto) formButtonMto.style.display = 'none';
  
            // 处理占位符替换和显示逻辑
            if (!hasSpOrMtoTag && variantInventory <= 0) {
              // 确保更新占位符的变体ID
              if (currentPlaceholder) {
                currentPlaceholder.dataset.variantId = this.currentVariant.id;
                
                // 创建 SI_trigger 元素
                siTrigger = document.createElement('a');
                siTrigger.href = '#';
                siTrigger.className = 'SI_trigger';
                siTrigger.textContent = 'Get Stock Alert';
                if (currentPlaceholder.dataset.productData) {
                  siTrigger.setAttribute('data-product-data', currentPlaceholder.dataset.productData);
                }
                siTrigger.setAttribute('data-variant-id', this.currentVariant.id);
                console.log('SI_trigger created:', siTrigger);
  
                // 替换占位符
                currentPlaceholder.parentNode.replaceChild(siTrigger, currentPlaceholder);
                console.log('Placeholder replaced with SI_trigger for variant:', this.currentVariant.id);
                currentPlaceholder = null; // 占位符已被替换
              } else if (siTrigger) {
                // 更新现有的SI_trigger
                siTrigger.setAttribute('data-variant-id', this.currentVariant.id);
              }
              
              // 确保 SI_trigger 的显示状态与 formButton 一致
              if (siTrigger) {
                siTrigger.style.display = 'inline-block';
                console.log('SI_trigger set to display:inline-block');
              }
            } else {
              if (siTrigger) siTrigger.style.display = 'none';
              if (currentPlaceholder) currentPlaceholder.style.display = 'none';
            }
          }
        }
  
        // 更新其他元素
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }
        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }
  
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
  
        if (inventoryDestination) {
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
        }
  
        // 根据库存设置按钮文字
        this.toggleAddButton(false, 'Add to Cart');
  
        // 更新折扣金额（添加错误处理）
        const salePriceLiquid = document.querySelector('.sale_price_liquid');
        try {
          if (salePriceLiquid) {
            if (this.currentVariant && this.currentVariant.compare_at_price > this.currentVariant.price) {
              const discountAmount = this.currentVariant.compare_at_price - this.currentVariant.price;
              const formattedDiscount = `$${(discountAmount / 100).toFixed(2)}`;
              salePriceLiquid.innerHTML = `-${formattedDiscount}`;
              salePriceLiquid.style.display = 'block';
            } else {
              salePriceLiquid.innerHTML = '';
              salePriceLiquid.style.display = 'none';
            }
          } else {
            console.warn('Element .sale_price_liquid not found');
          }
        } catch (error) {
          console.error('Error updating sale price:', error);
        }
  
        // 调用更新后的方法
        this.reinitializeTooltips();
        this.reinitializeCopyEvent();
        this.reinitializePriceMatch();
        this.updateMapRewards();
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

// 替换为你的新 reinitializeTooltips 方法
reinitializeTooltips() {
const skuElement = document.querySelector(`#Sku-${this.dataset.section} .copyme`);
if (skuElement) {
  const existingTooltip = bootstrap.Tooltip.getInstance(skuElement);
  if (existingTooltip) {
    existingTooltip.dispose();
  }
  new bootstrap.Tooltip(skuElement);
}
}

// 重新绑定复制功能的点击事件
reinitializeCopyEvent() {
  const copyMeElement = document.querySelector(`#Sku-${this.dataset.section} .copyme`);
  if (copyMeElement) {
    // 移除旧的事件监听器，避免重复绑定
    if (this.handleCopy) {
      copyMeElement.removeEventListener('click', this.handleCopy);
    }

    // 定义复制逻辑
    this.handleCopy = (event) => {
      const dataToCopy = copyMeElement.getAttribute('data-copy');
      const tempInput = document.createElement('input');
      tempInput.value = dataToCopy;
      document.body.appendChild(tempInput);
      copyMeElement.classList.add('highlighted');
      tempInput.select();
      tempInput.setSelectionRange(0, 99999); // For mobile devices
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      setTimeout(() => {
        copyMeElement.classList.remove('highlighted');
      }, 2000);
    };

    // 绑定新的事件监听器
    copyMeElement.addEventListener('click', this.handleCopy);
  }
}

// 更新方法：重新初始化 PRICE MATCH 按钮（触发插件逻辑）
reinitializePriceMatch() {
  const priceMatchButton = document.querySelector('#pricebeater');
  if (priceMatchButton) {
    console.log('Reinitializing Price Beater button:', priceMatchButton);

    // 移除旧的事件监听器，避免重复绑定
    if (this.handlePriceMatch) {
      priceMatchButton.removeEventListener('click', this.handlePriceMatch);
    }

    // 直接调用插件的 _openModal 方法
    this.handlePriceMatch = (event) => {
      event.preventDefault();
      console.log('PRICE MATCH clicked, triggering Price Beater plugin...');

      // 获取当前产品数据（与插件的 _createModalFrameElement 一致）
      const productPath = window.location.pathname.split('/').pop();
      const shopId = document.querySelector('.shop-id')?.getAttribute('data-shop-id') || 'jdmuscleusa.myshopify.com';
      const productTitle = encodeURIComponent(document.title);
      const productImage = encodeURIComponent(document.querySelector('img.product__media-image')?.src || '');
      const variantId = this.currentVariant?.id || '';
      const price = encodeURIComponent(
        document.querySelector('.price__sale .price-item--regular')?.textContent.replace('$', '') || ''
      );

      // 构建 iframe URL（与插件一致）
      const iframeUrl = `https://beatanyprice.spacesquirrel.net/widget/modal/shop/${shopId}/product/${productPath}?image=${productImage}&title=${productTitle}&url=${encodeURIComponent(window.location.pathname)}&variant_id=${variantId}&price=${price}`;

      // 直接调用插件的 _openModal 方法
      if (typeof SpaceSquirrePriceBeater !== 'undefined' && typeof SpaceSquirrePriceBeater._openModal === 'function') {
        SpaceSquirrePriceBeater._openModal(iframeUrl, {
          sqrl: true,
          'sqrl-msg': 'openModal',
          'sqrl-msg-product-data': {
            id: productPath,
            featured_image: productImage,
            title: decodeURIComponent(productTitle),
            url: window.location.pathname,
            variants: [{ id: variantId, price: price }],
          },
        });
      } else {
        console.warn('SpaceSquirrePriceBeater._openModal not found, using fallback');
        // 作为备用，插入 iframe（手动模拟插件行为）
        const modalWrap = document.getElementById('sqrl-price-match-wrap-modal');
        if (!modalWrap) {
          const wrap = document.createElement('div');
          wrap.id = 'sqrl-price-match-wrap-modal';
          wrap.setAttribute('data-button-setup-complete', '1');
          wrap.style.display = 'block';
          wrap.style.position = 'fixed';
          wrap.style.top = '0px';
          wrap.style.left = '0px';
          wrap.style.width = '100%';
          wrap.style.zIndex = '2147483647';
          wrap.style.overflow = 'hidden';
          wrap.style.height = '772px';

          const iframe = document.createElement('iframe');
          iframe.frameBorder = '0';
          iframe.scrolling = 'no';
          iframe.src = iframeUrl;
          iframe.style.width = '100%';
          iframe.style.maxWidth = '100%';
          iframe.style.height = '100%';

          wrap.appendChild(iframe);
          document.body.appendChild(wrap);
          console.log('Manually inserted Price Beater iframe:', iframeUrl);
        }
      }
    };

    // 绑定新的事件监听器
    priceMatchButton.addEventListener('click', this.handlePriceMatch);
    console.log('Price Match event bound to:', priceMatchButton);
  } else {
    console.warn('No #pricebeater element found on the page');
  }
}

updateMapRewards() {
try {
// 1) 取 sectionId（多重兜底）
const sectionId =
this.dataset?.section ||
this.dataset?.originalSection ||
this.closest?.('[data-section]')?.dataset?.section ||
'';
if (!sectionId) return;

// 2) 找容器（先按 id，再按 section 作用域内 class）
let rewardsEl = document.getElementById(`map-rewards-${sectionId}`);
if (!rewardsEl) {
  const scope =
    document.querySelector(`#MainProduct-${sectionId}, [data-section='${sectionId}']`) || document;
  rewardsEl = scope.querySelector('.map-rewards-text');
}

// 如果仍找不到，直接在价格块后“现场创建”一个
if (!rewardsEl) {
  const priceBox =
    document.getElementById(`price-${sectionId}`) ||
    document.querySelector(`[data-section='${sectionId}'] #price-${sectionId}`);
  if (priceBox && priceBox.parentNode) {
    rewardsEl = document.createElement('div');
    rewardsEl.id = `map-rewards-${sectionId}`;
    rewardsEl.className = 'map-rewards-text';
    rewardsEl.setAttribute('aria-live', 'polite');
    rewardsEl.style.cssText = 'display:none;';
    priceBox.parentNode.insertBefore(rewardsEl, priceBox.nextSibling);
  }
}
if (!rewardsEl) return;

// 3) 确保有 currentVariant（简单产品兜底）
if (!this.currentVariant) {
  try {
    const jsonText = this.querySelector('[type="application/json"]')?.textContent;
    if (jsonText) {
      const data = JSON.parse(jsonText);
      const firstVariant = Array.isArray(data) ? data[0] : (data?.variants?.[0] || null);
      if (firstVariant) this.currentVariant = firstVariant;
    }
  } catch (e) {}
  if (!this.currentVariant) {
    this.updateOptions?.();
    this.updateMasterId?.();
  }
  if (!this.currentVariant) return;
}

// 4) 读取价格（分）
const priceCents = Number(this.currentVariant.price);
// 若首屏数据尚未注入，稍后再试一次
if (!Number.isFinite(priceCents)) {
  setTimeout(() => this.updateMapRewards(), 80);
  return;
}

// 5) 计算 2%（允许 0 值也展示）
const rewardsCents = Math.round((priceCents || 0) * 0.02);
const rewards = (rewardsCents / 100).toFixed(2);

// 6) 写入并显示
const link = document.createElement('a');
link.href = 'https://jdmuscleusa.com/blogs/news/rewards';
link.target = '_blank';
link.rel = 'noopener noreferrer';
link.textContent = 'Earn $' + rewards + ' In JDMuscle Rewards!';

rewardsEl.textContent = ''; // 清空原内容
rewardsEl.appendChild(link);
rewardsEl.style.display = 'block';
} catch (e) {
console.error('updateMapRewards error:', e);
}
}


toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const mobileButton = document.querySelector('#addToCart span');

    if (!productForm && !mobileButton) return;

    const addButton = productForm?.querySelector('[name="add"]');
    const addButtonText = addButton?.querySelector('span');

    // 如果没有明确指定文字，且不是禁用状态，则不更改按钮文字
    if (!text && !disable) return;

    // 自定义逻辑：根据库存动态更新按钮文字
    const variantId = this.currentVariant ? this.currentVariant.id : null;
    const variantElement = document.querySelector(`[data-variant-id-data="${variantId}"]`);
    let finalText = text;
    if (variantElement) {
      const inventoryQuantity = parseInt(variantElement.getAttribute('qtyvar'), 10);
      finalText = inventoryQuantity > 0 ? 'Add to Cart' : 'Add to Cart';
      console.log('Updating button text - Variant ID:', variantId, 'Inventory:', inventoryQuantity, 'Text:', finalText);
    } else if (!finalText && disable) {
      finalText = window.variantStrings.unavailable; // 仅在禁用且无变体时显示 unavailable
    }

    // 更新 PC 端按钮
    if (addButton) {
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
      } else {
        addButton.removeAttribute('disabled');
      }
      if (finalText && addButtonText) addButtonText.textContent = finalText;
    }

    // 更新手机端按钮
    if (mobileButton && finalText) {
      mobileButton.textContent = finalText;
    }

    if (!modifyClass) return;
  }

setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('[name="add"] > span');
    const mobileButton = document.querySelector('#addToCart span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (addButton && addButtonText) {
      addButtonText.textContent = window.variantStrings.unavailable;
      addButton.setAttribute('disabled', 'disabled');
    }
    if (mobileButton) {
      mobileButton.textContent = window.variantStrings.unavailable;
    }
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    setTimeout(() => this.updateMapRewards(), 0);
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))



const accordionItemHeaders = document.querySelectorAll(".product-accordion-item-header");

accordionItemHeaders.forEach((accordionItemHeader, index) => {
   accordionItemHeader.addEventListener("click", event => {
     accordionItemHeader.classList.toggle("active");
     const accordionItemBody = accordionItemHeader.nextElementSibling;
     if(accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
     }
     else {
       accordionItemBody.style.maxHeight = 0;
     }
   });
      // Set height for the first child only
    if (index === 0) {
       const accordionItemBody = accordionItemHeader.nextElementSibling;
        accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
       accordionItemHeader.classList.add("active");
    }
});


  document.addEventListener('DOMContentLoaded', function () {

      var copyMeElement = document.querySelector('.copyme');

      copyMeElement.addEventListener('click', function () {
        // Get the value of the data-copy attribute
        var dataToCopy = copyMeElement.getAttribute('data-copy');

        // Create a temporary input element
        var tempInput = document.createElement('input');
        tempInput.value = dataToCopy;

        // Append the input element to the document
        document.body.appendChild(tempInput);

        copyMeElement.classList.add('highlighted');

        // Select the text inside the input element
        tempInput.select();
        tempInput.setSelectionRange(0, 99999); // For mobile devices

        // Copy the selected text
        document.execCommand('copy');

        // Remove the temporary input element
        document.body.removeChild(tempInput);

        setTimeout(function () {
          copyMeElement.classList.remove('highlighted');
        }, 2000);

      });
    });